export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const YEAR_FORMAT = 'YYYY';

export const MONTH_FORMAT = 'YYYY-MM';

export const DATE_FORMAT = 'YYYY-MM-DD';

export const TIME_FORMAT = 'HH:mm:ss';

export const TIME_MINUTE_FORMAT = 'HH:mm';

export const EXPORT_DATE_TIME_FORMAT = 'YYYYMMDD_HHmmss';

export const MOBILE_REG = /^1[0-9]{10}$/;

export const ID_CARD_REG = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;

// 手机号码 以1开头11位
export const PHONE_REG = /^1\d{10}$/;

/**
 * 价格 两位小数 空字符 最大99999.99
 * 0
 * 0.xx
 * xxx.xx
 * ''
 */
export const PRICE_REG = /^(0|[1-9]\d{0,4})(\.\d{1,2})?$|^$/;

// 金额正则表达式
// 0 | 正整数 | 正小数(小数点后最多两位)
export const AMOUNT_REG = /^(0|[1-9]\d*|[1-9]\d*\.\d{1,2}|0\.\d{1,2})$/;

// 金额最大值
export const AMOUNT_MAX = 99999.99;

// 金额可输入字符（数字和小数点）
export const AMOUNT_INUPUT = /^[0-9]+(\.\d|\d)*$/;
